module.exports = __webpack_public_path__ + "static/media/s60.db54a50e.jpg";